import axiosInstance from "../instance/AxiosInstance";
export const invoiceViewEffect = async (invoiceId) => {
  try {
    const response = await axiosInstance.get(
      `/invoice/getinvoice?invoice_id=${invoiceId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Invoice";
  }
};
export const invoiceViewAllEffect = async (payload = {}) => {
  const {
    pageNo = 1,
    pagesize = 10,
    search_by,
    search,
    type,
    date_from,
    customerId,
    vendorId,
    pagination_required = true, // :point_left: default true but can be overridden
  } = payload;
  const params = {
    pagination_required, // :point_left: now controlled by payload
    pagesize,
    pageNo,
  };
  // Add search parameters
  if (search) {
    params.search = search;
    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  }
  // Add time period and date parameters for sales/bookings reports
  if (type) {
    params.type = type;
  }
  if (date_from) {
    params.date_from = date_from;
  }
  // Add customer/vendor specific parameters
  if (customerId) {
    params.customer_id = customerId;
  }
  if (vendorId) {
    params.vendor_id = vendorId;
  }
  try {
    const response = await axiosInstance.get(
      `/reports/getbookingservicereports`,
      { params }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Invoice";
  }
};

export const invoiceViewsEffect = async () => {
  try {
    const response = await axiosInstance.get(
      `/reports/getbookingservicereports?pagination_required=false`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Invoice";
  }
};
export const customerInvoiceViewAllEffect = async (payload) => {
  const { customer_id, pageNo, pagesize, search, search_by } = payload;
  const params = {
    customer_id: customer_id,
    vendor_id: "",
  };

  if (search) {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
    params.search = search;

    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
  }

  try {
    const response = await axiosInstance.get(`/reports/bookinggetbycustomer`, {
      params,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Invoice";
  }
};

export const vendorInvoiceViewAllEffect = async (payload) => {
  const { vendor_id, pageNo, pagesize, search, search_by } = payload;
  const params = {
    customer_id: "",
    vendor_id: vendor_id,
  };

  if (search) {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
    params.search = search;

    if (search_by && search_by.trim() !== "") {
      params.search_by = search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = pagesize;
    params.pageNo = pageNo;
  }
  try {
    const response = await axiosInstance.get(`/reports/bookinggetbycustomer`, {
      params,
    });

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Fetch Invoice";
  }
};
